"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isBypassing(BYPASS_FLAG) {
    if (typeof BYPASS_FLAG !== 'undefined') {
        return BYPASS_FLAG;
    }
    return true;
}
exports.default = isBypassing;
// tslint:disable-next-line:no-any
function isEmpty(arg) {
    if (Object.prototype.toString.call(arg) === '[object Object]' ||
        Object.prototype.toString.call(arg) === '[object Array]') {
        return Object.keys(arg).length === 0;
    }
    if (typeof arg === 'number' ||
        typeof arg === 'boolean') {
        return false;
    }
    // null, undefined, NaN, "", false
    return !arg;
}
exports.isEmpty = isEmpty;



//////////////////
// WEBPACK FOOTER
// ../node_modules/kya/dist/exist/bypass.js
// module id = 317
// module chunks = 0